import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';

import classNames from 'classnames';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
//import {saveAs} from 'file-saver';
import { clone } from '../../../core/utils';
import {
  formatDate,
  formatGender,
  formatStatus,
} from '../../../components/renderers';
import { createItemList, create, isValid } from '../../../components/form';
import { extendedstyles } from '../../appstyles';
import { Box } from '@mui/material';

const s:any = {
  formcontainer: {
    overflow: 'scroll',
  },
  hide: {
    display: 'none',
  },
  spinner: {
    backgroundImage: 'url(assets/img/loading.gif)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    margin: 'auto',
    width: 80,
    height: 80,
  },
  minicolumn: {
    width: 200,
  },
};

class SendPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
    super(props);
    this.state = {
      source: {},
      preview: false,
      valid: true,
      count: 0,
    };
  }

  componentDidMount() {
    this.props.setValid(this.state.valid);
    //this.drawCard();
  }

  

  formconfig = () => {
    const config = {
      service: {
        name: 'review',
        title: 'Review Information',
        eform: [
          //:nam,:ati,:aci,:ayi,:mbn,:cbu,:cbp,:cbc,:cba,:lci,:dtl,:sts'
          { id: 'tmi', label: 'Team', type: 'rf', col: 1, req: 0, ops: {} },
          //{ id: 'tmc', label: 'Team Short Code', type: 'rf', col: 1, ops: {} },
          //{ id: 'coi', label: 'Country', type: 'rf', col:1, req: 0, ops: {} },

                // {id:'tmd',label:'Description',type:'ta',req:0,ops:{}},
                // {id:'tcd',label:'Date Created',type:'df',req:0,ops:{}},

          //Team member
          {id:'iid',label:'Member',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitor'}},
            {id:'iri',label:'Team Member Role',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'teamrole'}},
            {id:'ids',label:'Description',type:'ta',req:0,ops:{},},
            {id:'ixi',label:'Extra Info',type:'jf',req:0,ops:{}},
      
          //Inspection
          { id: 'ttl', label: 'Inspection', type: 'rf', col: 1, ops: {} },
          {id:'eni',label:'Entity',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectionentity'},chs:['lci']},
        // {id:'tmi',label:'Team',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'team'}},
          {id:'iti',label:'Inspection Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitoringtype'}},
          {id:'lci',label:'Location',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'inspectionlocation'},pns:['eni']},
          {id:'smr',label:'Summary',type:'tf',req:1,ops:{},},
          {id:'dat',label:'Due Date',type:'df',req:1,ops:{}},
          {id:'pri',label:'Priority',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitoringpriority'}},
          {id:'rli',label:'Risk Level',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'monitoringrisklevel'}},
          {id:'sti',label:'Inspection State',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'monitoringstate'}},

          //Item
          //{id:'qni',label:'Question',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'itemquestion'}},
          {id:'isi',label:'Item State',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'itemstate'}},
          //{ id: 'roi', label: 'Role', type: 'rf', col: 1, req: 0, ops: {} },
        ],
      },
      create: true,
      actions: { view: 'View' },
      panels: { view: 'column' },
    };
    return config;
  };

  mkColumns = (items: any, columns: any) => {
    const fields: any = {};
    console.log('items:', items, 'columns:', columns);
    items.map((item: any) => {
      let id = columns[item.id] || 1;
      let key = `col${id}`;
      if (!fields[key]) fields[key] = [];
      fields[key].push(item);
      return true;
    });
    return fields;
  };

  makecform = () => {
    const config = this.formconfig();
    const { record, classes, extras } = this.props;
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'view';
    const formatters = {dob:formatDate, gdi:formatGender,sts:formatStatus};
    const onChange = this.onChange.bind(this);
    extras.options = {fullWidth:false};
    const formitems = createItemList(mode,sdata,record,formatters,onChange, extras);
    
    const {eform} = config.service;
    const columns = eform.reduce((acc:any,v:any)=>{
      acc[v.id]=v.col;
      return acc;
    },{});
    
    const fields = this.mkColumns(formitems,columns);
    return fields;
  }

  makeform = () => {
    const config = this.formconfig();
    const { record, classes, extras } = this.props;
    console.log('record:', record);
    const sconfig = clone(config);
    const sdata = sconfig.service;
    const mode = 'view';
    const formatters = { dob: formatDate, sts: formatStatus };
    const onChange = this.onChange.bind(this);
    extras.options = { fullWidth: false };
    const form = create(mode,sdata,record,formatters,onChange,classes,extras);
    //const formitems = createItemList(mode,sdata,record,formatters,onChange, extras);
    return form;
  };

  onChange = (name: any) => (value: any) => {};

  makeview = () => {
    const { data, classes, ...others } = this.props;
    //console.log('send.dat', data);
    //console.log('send.others', others);
    const { data: record } = data;
    const config = this.formconfig();
    const { eform } = config.service;
    const rows = eform.reduce((acc: any, rec: any) => {
      const { id, label } = rec;
      let row: any = { id, label, value: record[id] };
      acc.push(row);
      return acc;
    }, []);
    return (
      <Box sx={{...s.viewroot}}>
        <Paper sx={{...s.viewpaper}}>
          <Table
            sx={{...s.viewtable}}
            size='small'
            aria-label='a dense table'
          >
            {/* <TableHead>
              <TableRow>
                <TableCell>Parameter</TableCell>
                <TableCell align="right">Value</TableCell>
              </TableRow>
            </TableHead> */}
            <TableBody>
              {rows.map((row: any) => (
                <TableRow key={row.id}>
                  <TableCell component='th' scope='row'>
                    {row.label}
                  </TableCell>
                  <TableCell align='left'>{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Box>
    );
  };

  renderview(form:any,loading:any,classes:any) {
    return (
      <Box sx={{...s.container, ...s.formcontainer}}>
        <Box className={loading ? classes.spinner : classes.hide}></Box>
        {form}
      </Box>
    );
  }

  rendercview(fields:any,loading:any,classes:any) {
    return (
      <Box sx={{...s.container, ...s.formcontainer}}>
        <Box sx={loading?{...s.spinner}:{...s.hide}}></Box>
        <Box component='form' id="requestform" sx={loading?{...s.hide}:{...s.columnform}}>
          {
            Object.keys(fields).map(key => (
              <Box key={key} sx={{...s.columnfieldset,...s.minicolumn}}>
                {fields[key].map((item:any)=>(<Box key={item.id}>{item.dom}</Box>))}
              </Box>
            ))
          }
        </Box>
      </Box>
    );
  }

  render() {
    const { loading, classes } = this.props;
    //const form = this.makeform();
    //const form = this.makeview();
    // return (
    //   <Box sx={...s.container, ...s.formcontainer}}>
    //     <Box className={loading ? classes.spinner : classes.hide}></Box>
    //     {form}
    //   </Box>
    // );

    // rendering column view form
    const fields = this.makecform();
    return this.rendercview(fields,loading,classes);

    // // rendering single view form
    // const form = this.makeform();
    // return this.renderview(form,loading,classes);

    // // rendering table view form
    // const form = this.makeview();
    // return this.renderview(form,loading,classes);
  }
}

SendPanel.propTypes = {
  //classes: PropTypes.object.isRequired,
};

export default SendPanel;
